import { CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";
import { useNavigate } from "react-router-dom";
import educationOwl from "@/assets/education-owl.png";

export const EducationHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-6 justify-between">
      <div className="flex items-center gap-6">
        <div className="w-24 h-24 flex items-center justify-center rounded-lg overflow-hidden">
          <img src={educationOwl} alt="Education Channel" className="w-24 h-24 object-contain" />
        </div>
        <div>
          <CardTitle className="text-2xl font-bold mb-2">Education</CardTitle>
          <CardDescription className="text-lg">
            Explore education knowledge domains and contribute to our collective intelligence
          </CardDescription>
        </div>
      </div>
      <div className="flex items-center gap-4">
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button 
                className="bg-black text-white hover:bg-primary transition-colors"
                onClick={() => navigate("/education/call-for-knowledge")}
              >
                CfK
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Call for Knowledge (demo)</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>

        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button 
                className="bg-black text-white hover:bg-primary transition-colors"
                onClick={() => navigate("/education/call-for-solutions")}
              >
                CfS
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Call for Solutions (demo)</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>

        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button 
                className="bg-black text-white hover:bg-primary transition-colors"
                onClick={() => navigate("/education/call-for-destruction")}
              >
                CfD
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>Call for Destruction (demo)</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </div>
  );
};
